// extracted by mini-css-extract-plugin
export default {"rateArticle":"FaqArticleBody_rateArticle__mNd0c"};